import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { logger } from '../utils/logger.util';


export interface TextViewerOpenOptions {
  title: string;
  text: string;
}

@Injectable({
  providedIn: 'root'
})
export class TextViewerService {
  private readonly requestSubject = new BehaviorSubject<TextViewerOpenOptions | null>(null);

  readonly request$ = this.requestSubject.asObservable();

  open(options: TextViewerOpenOptions): void {
    if (!options.text?.trim()) {
      logger.warn('[TextViewerService] open() requiert un texte non vide');
      return;
    }
    this.requestSubject.next(options);
  }

  close(): void {
    this.requestSubject.next(null);
  }
}
